/**
 * The icon scale. Five steps, and nothing between them.
 *
 * **Why a scale at all.** The platform was drawing icons at fifteen different
 * sizes — 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 24, 26, 28 and 34 — and
 * the differences were not decisions. The admin topbar signed you out with an
 * 18px icon while every other topbar in the platform used 20; the same trash
 * can was 15px in one row and 16px in the next. A 1px difference is not a
 * choice anyone can defend, but it is one the eye registers as sloppiness when
 * two of them sit in the same row.
 *
 * Five steps is few enough that picking one is obvious and the wrong pick is
 * visible. Each is named for its job, not its pixels, so a step can be retuned
 * once rather than hunted for.
 */
export const iconSize = {
  /** Inline with small text — inside a chip, a meta line, a dense list. */
  xs: 12,
  /** Dense controls: a row's action buttons, a compact list item. */
  sm: 14,
  /** The default. Buttons, inputs, menu items, list rows. */
  md: 16,
  /** Standalone icon buttons: a top bar, navigation, panel headers. */
  lg: 20,
  /** A mark that carries a whole state — an empty state, a confirmation. */
  xl: 28,
} as const;

export type IconSize = keyof typeof iconSize;
